/*
  Brand pages (brand2): everything that moves.
  - Jump bar under the hero, filled from every product section's heading, highlighting the one in view.
  - "Show more" and "Show sold out" buttons under each product grid.
  - Product photos on a white background are faded to a cut-out (same method as the old brand pages),
    then each tile takes a glow in the photo's own strongest colour.
  - Showcase swatches swap the big picture.
  - Reveal-on-scroll, and a gentle parallax on the hero layers (mouse only).
  Nothing here is needed to read or buy: without scripts every product is simply shown.
*/
(function () {
  if (window.__brand2) return;
  window.__brand2 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Worker: white background → see-through, plus the dominant colour ---------- */
  function workerBody() {
    var LOW = 225, STEP = 2, PURE = 250, POCKET = 0.001;
    function glow(px, w, h) {
      // Average of the strongly coloured, reasonably bright pixels: the label art, not the shadows.
      var r = 0, g = 0, b = 0, n = 0, total = w * h, step = total > 90000 ? 3 : 1;
      for (var i = 0; i < total; i += step) {
        var o = i * 4; if (px[o + 3] < 180) continue;
        var R = px[o], G = px[o + 1], B = px[o + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B);
        if (mx < 60) continue;
        var s = (mx - mn) / mx; if (s < 0.38) continue;
        var wgt = s * s; r += R * wgt; g += G * wgt; b += B * wgt; n += wgt;
      }
      if (n < 20) return null;
      r /= n; g /= n; b /= n;
      // Lift it so it glows on a dark tile.
      var mx2 = Math.max(r, g, b, 1), k = 200 / mx2;
      return [Math.round(r * k), Math.round(g * k), Math.round(b * k)];
    }
    function prepare(px, w, h) {
      var total = w * h;
      var corners = [0, w - 1, (h - 1) * w, total - 1];
      for (var c = 0; c < corners.length; c++) { if (px[corners[c] * 4 + 3] < 20) return 'cutout'; }
      var tone = function (k) { var o = k * 4; return px[o + 3] > 200 ? Math.min(px[o], px[o + 1], px[o + 2]) : -1; };
      var low = LOW, whiteProduct = false;
      (function () {
        var bg = new Uint8Array(total), stack = [], i, x, y, t, bgCount = 0, offWhite = 0, pure = 0;
        for (x = 0; x < w; x++) { stack.push(x, x + (h - 1) * w); }
        for (y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
        while (stack.length) {
          i = stack.pop();
          if (bg[i] || tone(i) < PURE) continue;
          bg[i] = 1; bgCount++; x = i % w;
          if (x > 0) stack.push(i - 1); if (x < w - 1) stack.push(i + 1); if (i >= w) stack.push(i - w); if (i < total - w) stack.push(i + w);
        }
        var product = total - bgCount; if (product <= 0) return;
        for (i = 0; i < total; i++) { if (bg[i]) continue; t = tone(i); if (t >= PURE) pure++; else if (t >= 235) offWhite++; }
        if (offWhite / product >= 0.3 && pure / product < 0.15) whiteProduct = true;
      })();
      var fade = new Uint8Array(total), faded = 0;
      var spread = function (stack) {
        var i, x;
        while (stack.length) {
          i = stack.pop(); if (fade[i] || tone(i) < low) continue;
          fade[i] = 1; faded++; x = i % w;
          if (x > 0) stack.push(i - 1); if (x < w - 1) stack.push(i + 1); if (i >= w) stack.push(i - w); if (i < total - w) stack.push(i + w);
        }
      };
      var spreadSmooth = function (stack) {
        var i, x, j, t, n4;
        for (j = 0; j < stack.length; j++) { if (!fade[stack[j]]) { fade[stack[j]] = 1; faded++; } }
        while (stack.length) {
          i = stack.pop(); x = i % w;
          n4 = [x > 0 ? i - 1 : -1, x < w - 1 ? i + 1 : -1, i >= w ? i - w : -1, i < total - w ? i + w : -1];
          for (j = 0; j < 4; j++) { var m = n4[j]; if (m < 0 || fade[m]) continue; t = tone(m); if (t >= PURE || (t >= LOW && t >= tone(i) - STEP)) { fade[m] = 1; faded++; stack.push(m); } }
        }
      };
      var seeds = [], x, y, k;
      for (x = 0; x < w; x++) { seeds.push(x, x + (h - 1) * w); }
      for (y = 0; y < h; y++) { seeds.push(y * w, y * w + w - 1); }
      var edgeSeeds = [];
      for (k = 0; k < seeds.length; k++) { if (tone(seeds[k]) >= PURE) edgeSeeds.push(seeds[k]); }
      if (whiteProduct) spreadSmooth(edgeSeeds); else spread(edgeSeeds);
      if (faded / total < 0.05) return 'plain';
      var visited = new Uint8Array(total), minPocket = Math.round(total * POCKET);
      for (var start = 0; start < (whiteProduct ? 0 : total); start++) {
        if (fade[start] || visited[start] || tone(start) < PURE) continue;
        var pocket = [start]; visited[start] = 1;
        for (k = 0; k < pocket.length; k++) {
          var n = pocket[k], nx = n % w;
          var around = [nx > 0 ? n - 1 : -1, nx < w - 1 ? n + 1 : -1, n >= w ? n - w : -1, n < total - w ? n + w : -1];
          for (var q = 0; q < 4; q++) { var m = around[q]; if (m >= 0 && !fade[m] && !visited[m] && tone(m) >= PURE) { visited[m] = 1; pocket.push(m); } }
        }
        if (pocket.length >= minPocket) spread(pocket.slice());
      }
      for (var i = 0; i < total; i++) {
        if (!fade[i]) continue;
        var o = i * 4, a = Math.max(0, Math.min(1, (255 - tone(i)) / (255 - low)));
        if (a <= 0.004) { px[o + 3] = 0; continue; }
        for (var ch = 0; ch < 3; ch++) { px[o + ch] = Math.max(0, Math.min(255, Math.round((px[o + ch] - 255 * (1 - a)) / a))); }
        px[o + 3] = Math.round(255 * a);
      }
      return 'faded';
    }
    // Where the product itself sits in the picture (ignoring faint shadows), for sections that trim the empty space.
    function bounds(px, w, h) {
      var x0 = w, y0 = h, x1 = -1, y1 = -1, x, y, row;
      for (y = 0; y < h; y++) { row = y * w * 4; for (x = 0; x < w; x++) { if (px[row + x * 4 + 3] > 70) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } } }
      return x1 < 0 ? null : [x0, y0, x1, y1];
    }
    self.onmessage = function (e) {
      var d = e.data, px = new Uint8ClampedArray(d.buffer), result, colour = null, box = null;
      try { result = prepare(px, d.w, d.h); colour = glow(px, d.w, d.h); if (d.trim && result !== 'plain') box = bounds(px, d.w, d.h); } catch (err) { result = 'plain'; }
      self.postMessage({ id: d.id, result: result, colour: colour, box: box, buffer: d.buffer }, [d.buffer]);
    };
  }

  var worker = null, jobs = {}, nextId = 1, TIMEOUT = 8000;
  function getWorker() {
    if (worker) return worker;
    worker = new Worker(URL.createObjectURL(new Blob(['(' + workerBody.toString() + ')();'], { type: 'text/javascript' })));
    worker.onmessage = function (e) { var job = jobs[e.data.id]; if (!job) return; delete jobs[e.data.id]; job(e.data.result, e.data.buffer, e.data.colour, e.data.box); };
    worker.onerror = function () { for (var id in jobs) { jobs[id]('plain'); } jobs = {}; };
    return worker;
  }
  function processTile(img, box) {
    var media = box || img.closest('.b2-card__media'); if (!media || media.dataset.tile) return;
    if (media.closest('[data-b2-plain]')) { media.dataset.tile = 'plain'; return; } // light tiles: the photo is shown as it is
    var card = img.closest('.b2-card'), trim = !!media.closest('[data-b2-trim]');
    media.dataset.tile = 'pending';
    setTimeout(function () { if (media.dataset.tile === 'pending') media.dataset.tile = 'plain'; }, TIMEOUT);
    var source = new Image(); source.crossOrigin = 'anonymous';
    source.onload = function () {
      try {
        var w = source.naturalWidth, h = source.naturalHeight, canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d'); ctx.drawImage(source, 0, 0);
        var data = ctx.getImageData(0, 0, w, h), id = nextId++;
        jobs[id] = function (result, buffer, colour, box) {
          if (media.dataset.tile !== 'pending') return;
          if (colour && card) card.style.setProperty('--glow', colour.join(' '));
          var cut = trim && box && buffer && result !== 'plain';
          if (!cut && (result === 'cutout' || result === 'plain' || !buffer)) { media.dataset.tile = result === 'cutout' ? 'cutout' : 'plain'; return; }
          ctx.putImageData(new ImageData(new Uint8ClampedArray(buffer), w, h), 0, 0);
          var out = canvas;
          if (cut) {
            // "Trim empty space" (section setting): keep only the product, so it fills the tile
            var pad = Math.round(Math.max(w, h) * 0.02), bx = Math.max(0, box[0] - pad), by = Math.max(0, box[1] - pad);
            var bw = Math.min(w, box[2] + pad + 1) - bx, bh = Math.min(h, box[3] + pad + 1) - by;
            if (bw > 8 && bh > 8 && (bw < w * 0.95 || bh < h * 0.95)) { out = document.createElement('canvas'); out.width = bw; out.height = bh; out.getContext('2d').drawImage(canvas, bx, by, bw, bh, 0, 0, bw, bh); }
            else if (result === 'cutout') { media.dataset.tile = 'cutout'; return; }
          }
          out.toBlob(function (blob) {
            if (media.dataset.tile !== 'pending') return;
            if (!blob) { media.dataset.tile = 'plain'; return; }
            img.removeAttribute('srcset'); img.src = URL.createObjectURL(blob); media.dataset.tile = result === 'cutout' ? 'cutout' : 'faded';
          }, 'image/png');
        };
        getWorker().postMessage({ id: id, w: w, h: h, trim: trim, buffer: data.data.buffer }, [data.data.buffer]);
      } catch (e) { media.dataset.tile = 'plain'; }
    };
    source.onerror = function () { media.dataset.tile = 'plain'; };
    source.src = img.currentSrc || img.src;
  }

  /* ---------- Jump bar ---------- */
  function jumpBar() {
    var bar = document.querySelector('.b2-jump'); if (!bar) return;
    var secs = [].slice.call(document.querySelectorAll('[data-jump]')).filter(function (s) { return s.id && s.getAttribute('data-jump'); });
    if (secs.length < 2) { bar.remove(); return; }
    var ul = document.createElement('ul');
    secs.forEach(function (s) {
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + s.id; a.textContent = s.getAttribute('data-jump'); li.appendChild(a); ul.appendChild(li);
    });
    bar.appendChild(ul);
    var links = ul.querySelectorAll('a');
    function setTop() {
      var stuck = document.querySelector('.sticky_nav--stick, .main-nav__wrapper.sticky_nav--stick');
      var hdr = stuck || document.querySelector('.sticky_nav');
      var top = 0;
      if (hdr) { var cs = getComputedStyle(hdr); if (cs.position === 'fixed' || cs.position === 'sticky') top = hdr.getBoundingClientRect().height; }
      document.body.style.setProperty('--b2-top', Math.round(top) + 'px');
    }
    setTop(); window.addEventListener('resize', setTop); window.addEventListener('scroll', setTop, { passive: true });
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) current = en.target; });
        if (!current) return;
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current.id); });
        var act = ul.querySelector('.is-active'); if (act && act.scrollIntoView) { var r = act.getBoundingClientRect(), ur = ul.getBoundingClientRect(); if (r.left < ur.left || r.right > ur.right) ul.scrollTo({ left: act.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' }); }
      }, { rootMargin: '-40% 0px -55% 0px' });
      secs.forEach(function (s) { io.observe(s); });
    }
  }

  /* ---------- Show more / Show sold out ---------- */
  function moreButtons() {
    document.querySelectorAll('.b2-products').forEach(function (sec) {
      var box = sec.querySelector('.b2-more'); if (!box) return;
      var more = sec.querySelectorAll('.b2-card[data-more]:not([data-soldout])').length;
      var out = sec.querySelectorAll('.b2-card[data-soldout]').length;
      // nothing in stock in this row: show the sold-out products straight away, so the row is never empty behind a button
      if (out && !sec.querySelector('.b2-card:not([data-soldout])')) sec.classList.add('is-showing-soldout');
      if (more) {
        var b1 = document.createElement('button'); b1.type = 'button'; b1.className = 'b2-btn b2-btn--ghost';
        b1.textContent = 'Show ' + more + ' more';
        b1.addEventListener('click', function () { sec.classList.toggle('is-expanded'); var on = sec.classList.contains('is-expanded'); b1.textContent = on ? 'Show fewer' : 'Show ' + more + ' more'; if (!on) sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); reveal(); });
        box.appendChild(b1);
      }
      // sections set to show sold-out products straight away get no Show/Hide sold out button
      if (out && !sec.classList.contains('is-showing-soldout')) {
        var b2 = document.createElement('button'); b2.type = 'button'; b2.className = 'b2-btn b2-btn--ghost';
        var open0 = sec.classList.contains('is-showing-soldout');
        b2.textContent = open0 ? 'Hide sold out' : 'Show sold out (' + out + ')';
        b2.addEventListener('click', function () { sec.classList.toggle('is-showing-soldout'); var on = sec.classList.contains('is-showing-soldout'); b2.textContent = on ? 'Hide sold out' : 'Show sold out (' + out + ')'; reveal(); });
        box.appendChild(b2);
      }
    });
  }

  /* ---------- Showcase swatches ---------- */
  function showcases() {
    document.querySelectorAll('.b2-showcase').forEach(function (sc) {
      var img = sc.querySelector('[data-main]'), name = sc.querySelector('[data-name]'), price = sc.querySelector('[data-price]'), link = sc.querySelector('[data-link]'), note = sc.querySelector('[data-note]');
      if (img) { img.dataset.src = img.getAttribute('src'); var st0 = img.closest('.b2-showcase__stage'); if (st0 && 'Worker' in window) processTile(img, st0); }
      var sws = sc.querySelectorAll('.b2-swatch');
      sws.forEach(function (sw) {
        sw.addEventListener('click', function () {
          sws.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
          sw.classList.add('is-on'); sw.setAttribute('aria-pressed', 'true');
          if (img && sw.dataset.image && img.dataset.src !== sw.dataset.image) {
            img.classList.add('is-swapping');
            var stage = img.closest('.b2-showcase__stage');
            var next = new Image(); next.onload = function () { img.dataset.src = sw.dataset.image; img.src = sw.dataset.image; img.classList.remove('is-swapping'); if (stage) { delete stage.dataset.tile; processTile(img, stage); } }; next.onerror = function () { img.classList.remove('is-swapping'); }; next.src = sw.dataset.image;
          }
          if (name) name.textContent = sw.dataset.title || '';
          if (price) price.textContent = sw.dataset.priceText || '';
          if (note) note.textContent = sw.dataset.available === 'false' ? 'Sold out' : '';
          if (link && sw.dataset.url) link.href = sw.dataset.url;
        });
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = null;
  function reveal() {
    var els = document.querySelectorAll('.b2-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!revealIO) revealIO = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { if (getComputedStyle(e).display === 'none') return; revealIO.observe(e); });
  }

  /* ---------- Hero parallax ---------- */
  function parallax() {
    var stage = document.querySelector('.b2-stage'); if (!stage || reduce) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var layers = stage.querySelectorAll('.b2-layer'); if (!layers.length) return;
    var hero = stage.closest('.b2-hero') || stage, raf = 0, mx = 0, my = 0;
    layers.forEach(function (l) { l.addEventListener('animationend', function () { l.classList.add('is-live'); }); });
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 28; my = ((e.clientY - r.top) / r.height - 0.5) * 20;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; stage.style.setProperty('--mx', mx.toFixed(1) + 'px'); stage.style.setProperty('--my', my.toFixed(1) + 'px'); });
    });
    hero.addEventListener('mouseleave', function () { stage.style.setProperty('--mx', '0px'); stage.style.setProperty('--my', '0px'); });
  }

  function start() {
    document.documentElement.classList.add('b2-ready');
    jumpBar(); moreButtons(); showcases(); parallax();
    // Stagger index for tiles in each grid.
    document.querySelectorAll('.b2-grid, .b2-lines').forEach(function (g) { [].forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i % 10); c.classList.add('b2-reveal'); }); });
    reveal();
    var tiles = document.querySelectorAll('.b2-card__media img');
    if (!('Worker' in window) || !('IntersectionObserver' in window)) { tiles.forEach(function (img) { var m = img.closest('.b2-card__media'); if (m) m.dataset.tile = 'plain'; }); return; }
    var watcher = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { watcher.unobserve(en.target); processTile(en.target); } }); }, { rootMargin: '900px' });
    tiles.forEach(function (img) { watcher.observe(img); });
    // Hidden tiles (behind Show more) are processed when they appear.
    document.addEventListener('click', function () { setTimeout(function () { document.querySelectorAll('.b2-card__media:not([data-tile]) img').forEach(function (img) { watcher.observe(img); }); }, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
